import { api } from "./api";
import { CambiosCierreResponse } from "../types/cambiosCierre";

export const CambiosCierreService = {
    // Crear nuevo cambio de cierre
    crear: (data: CambiosCierreResponse) => {
        return api.post("/cambiosCierre", data);
    },

    // Obtener cambios de cierre por agente
    getByAgente: (idAgente: number) => {
        return api.get(`/cambiosCierre/agente/${idAgente}`);
    },

    // Desactivar cambio de cierre
    desactivar: (idCambiosCierre: number) => {
        return api.put(`/cambiosCierre/${idCambiosCierre}/desactivar`);
    }
}